// extracted by mini-css-extract-plugin
export default {"bilet_nav":"Bilet_bilet_nav__layxR"};